// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"407":"panel","441":"superadmin","785":"panel-senat","884":"admin","933":"auth","974":"senat-admin"}[chunkId] || chunkId) + "." + {"70":"ecb35765","148":"754c067f","306":"c802324e","364":"f33cc467","407":"1ff981d9","441":"64599ca3","785":"b5793ec3","884":"4e160245","933":"852c47f8","974":"d77a39ff"}[chunkId] + ".js";
};